import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
Vue.config.productionTip = false
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './assets/style/resrt.css'

Vue.use(Antd)
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: 'F0i6SrLmHquLVNLCqpExxPrj8mWVdFwx'
})
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);
import "swiper/dist/css/swiper.css";

import VueLazyLoad from 'vue-lazyload'; // 懒加载
Vue.use(VueLazyLoad, {
    error: './assets/imgs/load-error.png'
        //error: require('./assets/imgs/load-error.png'), // 加载错误的图片
        // loading: require('./assets/imgs/load-on.png') // 加载时的图片
});

// 导入挂载接口
import './api'
import axios from 'axios'
Vue.prototype.$axios = axios
// axios.defaults.baseURL = 'http://47.105.178.230:9898/dev-api';
// axios.defaults.baseURL = 'http://localhost:8080';
axios.defaults.baseURL = '/dev-api';
axios.interceptors.request.use(config => {

    let url = config.url
    if (url.indexOf('frontapi/expo/main/list') != -1) {
        encodeParam(config);
    }
    if (url.indexOf('frontapi/service/information/getDetail') != -1) {
        encodeParam(config);
    }

    return config
});

function encodeParam(config) {
    // get参数编码
    let url = config.url
    if (config.method === 'get' && config.params) {
        url += '?'
        let keys = Object.keys(config.params)
        for (let key of keys) {
            url += `${encodeURIComponent(key)}=${encodeURIComponent(config.params[key])}&`
        }
        url = url.substring(0, url.length - 1)
        config.params = {}
    }
    config.url = url;
}

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
